'use client';

import { useCallback, useRef, useState } from 'react';
import { useToast } from '@/shared/providers';
import { downloadElementsAsPdf } from '@/shared/utils';
interface UseDocumentoPdfDownloadInput {
  fileName: string | null;
}
export function useDocumentoPdfDownload({
  fileName
}: UseDocumentoPdfDownloadInput) {
  const {
    showError,
    showSuccess
  } = useToast();
  const documentoRef = useRef<HTMLDivElement | null>(null);
  const [isDownloadingPdf, setIsDownloadingPdf] = useState(false);
  const baixarPdf = useCallback(async () => {
    const container = documentoRef.current;
    if (!container || !fileName) return;
    const paginas = Array.from(container.querySelectorAll<HTMLElement>('[data-doc-page]'));
    setIsDownloadingPdf(true);
    try {
      await downloadElementsAsPdf({
        elements: paginas,
        fileName
      });
      showSuccess('PDF gerado com sucesso');
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Falha ao gerar o PDF';
      showError('Erro ao gerar PDF', message);
    } finally {
      setIsDownloadingPdf(false);
    }
  }, [fileName, showError, showSuccess]);
  return {
    documentoRef,
    isDownloadingPdf,
    baixarPdf
  };
}